import * as React from 'react'
import { EmptyCard, LocationSelector } from '../../atoms'
import { MatchPairProps } from '../../typings'

export const NoSelectionBody: React.FC<MatchPairProps> = (props) => (
  <EmptyCard>
    <LocationSelector {...props} />
  </EmptyCard>
)
NoSelectionBody.displayName = 'NoSelectionBody'
